module.exports = __webpack_public_path__ + "static/media/IMG_6561.c6dfa254.JPG";